import React from "react";
import AzureVDLandingPage from "./AzureVDLandingPage";

function App() {
  return <AzureVDLandingPage />;
}

export default App;
